import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../base.service';



@Injectable({
  providedIn: 'root'
})
export class InvoiceHistoryTableService {

  constructor(private http: HttpClient, private BaseService: BaseService) {}


  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }


  getByPartnerORClient(body: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/Invoice/GetByPartnerORClient', body, {
      headers,
    });
  }



}
